<template>
    <Navbar/>

    <div class="container-fluid m-0 p-0">
        <div class="d-flex" style="height: 120vh">
            <Sidebar/>
            <main class="  cssDesignSidebar">
                <router-view/>
            </main>
            
        </div>
          <div class="footer d-flex">
        <div class="orange-row"></div>
        <div class="triangle">
          <img src="../../assets/images/arrow-down.png" />
        </div>
      </div>
    </div>

    <AlartModal  state="success" v-if="successModal" :message="successMessage"    imagePath="okImage.svg" @close-modal="closeSuccessModalHandler"/>
    <AlartModal state="error" v-if="errorModal"   :message="errorMessage" imagePath="close.png" @close-modal="closeErrorModalHandler"/>
</template>

<script>
    import Navbar from "../components/Navbar";
    import Sidebar from "../components/Sidebar";
    import AlartModal from  "../components/AlartModal"
    import {computed} from "vue";
    import {useStore} from "vuex";

    export default {
        name: 'wrapper-page',
        components: {
            Navbar,
            Sidebar,
            AlartModal
        },

        setup(){
            const store = useStore();

            const closeSuccessModalHandler = async () => {
                await store.dispatch('setSuccessModal', false);
            };

            const closeErrorModalHandler = async () => {
                await store.dispatch('setErrorModal', false);
            };
            return{
                closeErrorModalHandler,
                closeSuccessModalHandler,
                successModal: computed(() => store.state.settings.successModal),
                errorModal: computed(() => store.state.settings.errorModal),
                successMessage: computed(() => store.state.settings.successMessage),
                errorMessage: computed(() => store.state.settings.errorMessage),
            }
        }
    }
</script>

<style>
    /*body {*/
    /*    background-image: linear-gradient(#044D6B, #021A24);*/
    /*}*/
body{
overflow:hidden;
}
.cssDesignSidebar {
    /*margin: 30px 34px 24px 33px;*/
      
    height: 88vh;
    width:calc(100% - 250px);
    padding: 120px 20px 0 30px;
    /*margin-left: 13rem !important;*/
    /*margin-top: 1rem !important;*/
}
.footer {
  position: absolute;
  bottom:-6px;
  width: 90%;
  align-items: flex-end;
}

.orange-row {
  width: 100%;
  height: 20px;
  background-color: #e95626;
}

.triangle {
  position: absolute;
  position: absolute;
  right: -30px;
  top: -18px;
  width:55px;
}

.triangle img {
  width: 85%;
}
@media(max-width:1280px){
.orange-row {
  height: 15px;
}
.triangle {
  width:45px;
}
.cssDesignSidebar{
  padding-inline: 0 !important;
  padding: 70px 0 0 0 !important;
  width: calc(100% - 200px);
}
}

</style>